import { g as t } from "./themes-5f0b3c3d.mjs";
const o = () => `
a.content-link {
    display: inline-block !important;
    align-items: center !important;
    font-family: ${t.primitive.fontFamilies.inter.value} !important;
    color: ${t.primitive.color.skyview[1100].value} !important;
    font-style: normal !important;
    font-weight: ${t.primitive.fontWeights.inter.medium} !important;
    font-size: ${t.primitive.fontSize.xsmall} !important;
    line-height: ${t.primitive.lineHeights.xsmall} !important;

    &:link {
      color: ${t.primitive.color.skyview[1100].value} !important;
      text-decoration: none !important;
    }
    &:visited {
      color: ${t.primitive.color.fordBlue[800].value} !important;
      text-decoration: none !important;
    }
    &:hover {
      color: ${t.primitive.color.skyview[1300].value} !important;
      text-decoration: underline !important;
      text-decoration-color: ${t.primitive.color.skyview[1300].value} !important;
      text-underline-offset: 5px !important;

    }
    &:active {
      color: ${t.primitive.color.fordBlue[800].value} !important;
      text-decoration: underline !important;
      text-decoration-color: ${t.primitive.color.fordBlue[800].value} !important;
      text-underline-offset: 5px !important;
    }
    &:focus {
      outline: none !important;
    }
    &:focus-visible {
      outline: ${t.primitive.borderWidth["2x"].value} solid ${t.primitive.color.skyview[1e3].value} !important;
      border-radius: ${t.primitive.radius["2x"].value} !important;
      outline-offset: ${t.primitive.space["1x"].value} !important;
    }
  }
`, e = () => `
a {
    display: inline-block !important;
    align-items: center !important;
    font-family: ${t.primitive.fontFamilies.inter.value} !important;
    color: ${t.primitive.color.skyview[1100].value} !important;
    font-style: normal !important;
    font-weight: ${t.primitive.fontWeights.inter.medium} !important;
    font-size: ${t.primitive.fontSize.xsmall} !important;
    line-height: ${t.primitive.lineHeights.xsmall} !important;

    &:link {
      color: ${t.primitive.color.skyview[1100].value} !important;
      text-decoration: none !important;
    }
    &:visited {
      color: ${t.primitive.color.fordBlue[800].value} !important;
      text-decoration: none !important;
    }
    &:hover {
      color: ${t.primitive.color.skyview[1300].value} !important;
      text-decoration: underline !important;
      text-decoration-color: ${t.primitive.color.skyview[1300].value} !important;
      text-underline-offset: 5px !important;

    }
    &:active {
      color: ${t.primitive.color.fordBlue[800].value} !important;
      text-decoration: underline !important;
      text-decoration-color: ${t.primitive.color.fordBlue[800].value} !important;
      text-underline-offset: 5px !important;
    }
    &:focus {
      outline: none !important;
    }
    &:focus-visible {
      outline: ${t.primitive.borderWidth["2x"].value} solid ${t.primitive.color.skyview[1e3].value} !important;
      border-radius: ${t.primitive.radius["2x"].value} !important;
      outline-offset: ${t.primitive.space["1x"].value} !important;
    }
  }
`, r = () => `
//*****Superscript styles*****
  sup {
    line-height: 0 !important;
    font-size: inherit !important;
    a {
      font-size: 75% !important;
      text-decoration: none !important;
    }
    a:hover,
    a:active {
      text-underline-offset: 2px !important;
      text-decoration: underline !important;
    }
    a.disclosure-superscript-link {
      font-size: 75% !important;
      text-underline-offset: 2px !important;
      color: #0564d7 !important;
      // focus style for <sup> tag under heading text
      outline-offset: 1px !important;
      border-radius: 2px !important;
    }
    a:visited,
    a.disclosure-superscript-link:visited {
      color: #333a7c !important;
      text-decoration: none !important;
    }
    a:hover,
    a.disclosure-superscript-link:hover {
      color: #044ea7 !important; 
      text-decoration: underline !important;
      text-decoration-color: #044ea7 !important;
    }
    a:active,
    a.disclosure-superscript-link:active {
      color: #333a7c !important;
      text-decoration: underline !important;
      text-decoration-color: #333a7c;
    }
  }
  sup:not(:has(a)) {
    font-size: 75% !important;
  }
  /* For <sup> tag under heading text */
  h1 sup,
  h2 sup,
  h3 sup,
  h4 sup,
  h5 sup,
  h6 sup {
    font-size: inherit !important;
    a {
      font-size: 50% !important;
      text-decoration: none !important;
    }
    a:hover {
      text-underline-offset: 2px !important;
      text-decoration: underline !important;
    }
    a,
    a.disclosure-superscript-link {
      font-size: 50% !important;
      text-underline-offset: 2px !important;
    }
  }
  h1 sup:not(:has(a)),
  h2 sup:not(:has(a)),
  h3 sup:not(:has(a)),
  h4 sup:not(:has(a)),
  h5 sup:not(:has(a)),
  h6 sup:not(:has(a)) {
    font-size: 50% !important;
  }
  //*****Superscript styles*****
`;
export {
  r as a,
  o as b,
  e as c
};
